import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { techStackSchema } from "./schema";
import { fetchTechStackData } from "./read";
import { useUpdateTechStack } from "../update/mutation";
import { useCreateTechStack } from "../create/mutation";

export const useTechStackForm = ({ techStackId }) => {
  const form = useForm({
    resolver: zodResolver(techStackSchema),
    defaultValues: {
      name: "",
    },
  });

  const updateTechStack = useUpdateTechStack();
  const createTechStack = useCreateTechStack();

  const handleCreate = async (context) => {
    const item = context.values;
    await createTechStack.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateTechStack.mutateAsync({ techStackId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchTechStackData({ techStackId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
